<template>
<div class="case-popup case-popup--dk-facts">

        <div class="case-popup__close-btn close-button close-button--white-icon" @click="$emit('close')">CLOSE</div>

        <div class="case-popup__window">

            <div class="case-popup__header">
                <div class="case-popup__heading">{{factsAboutDk.heading}}</div>
                <div class="case-popup__subheading">{{factsAboutDk.subHeading}}</div>
            </div>

            <div class="case-popup__navigation">
                <div class="case-popup__nav-button" @click="currentTab = 'today'" :class="{'case-popup__nav-button--selected': currentTab === 'today'}">{{tabTodayLabel}}</div>
                <div class="case-popup__nav-button" @click="currentTab = '2030'" :class="{'case-popup__nav-button--selected': currentTab === '2030'}">{{tab2030Label}}</div>
                <div class="case-popup__nav-button" @click="currentTab = '2050'" :class="{'case-popup__nav-button--selected': currentTab === '2050'}">{{tab2050Label}}</div>
            </div>


            <div v-show="currentTab === 'today'" class="case-popup__tab case-popup__tab--today">

                <div class="case-popup__main-media">
                    <CaseSlideshow :slidesData="factsAboutDk.mediaToday"></CaseSlideshow>
                </div>

                <div class="case-popup__info-box">
                    <ScrollBar class="case-popup__info-box-scroll">
                        <div class="case-popup__info-box-heading">{{factsAboutDk.headingToday}}</div>
                        <div class="case-popup__info-box-content" v-html="factsAboutDk.textToday"></div>
                    </ScrollBar>
                </div>

                <div v-if="factsAboutDk.factsToday" class="case-popup__facts facts" :class="{'facts--single-column': factsAboutDk.factsToday.length <= 4}">
                    <div v-for="(fact, i) in factsAboutDk.factsToday" v-bind:key="i" class="facts__fact">
                        <div class="facts__icon">
                            <img :src="imageUrl(fact.image)">
                        </div>
                        <div class="facts__info" v-html="fact.text"></div>
                    </div>
                </div>

            </div>

            <div v-show="currentTab === '2030'" class="case-popup__tab case-popup__tab--2030">

                <div class="case-popup__main-media">
                    <CaseSlideshow :slidesData="factsAboutDk.media2030"></CaseSlideshow>
                </div>

                <div class="case-popup__info-box">
                    <ScrollBar class="case-popup__info-box-scroll">
                        <div class="case-popup__info-box-heading">{{factsAboutDk.heading2030}}</div>
                        <div class="case-popup__info-box-content" v-html="factsAboutDk.text2030"></div>
                    </ScrollBar>
                </div>

                <div v-if="factsAboutDk.facts2030" class="case-popup__facts facts" :class="{'facts--single-column': factsAboutDk.facts2030.length <= 4}">
                    <div v-for="(fact, i) in factsAboutDk.facts2030" v-bind:key="i" class="facts__fact">
                        <div class="facts__icon">
                            <img :src="imageUrl(fact.image)">
                        </div>
                        <div class="facts__info" v-html="fact.text"></div>
                    </div>
                </div>

            </div>

            <div v-show="currentTab === '2050'" class="case-popup__tab case-popup__tab--2050">
            
                <div class="case-popup__main-media">
                    <CaseSlideshow :slidesData="factsAboutDk.media2050"></CaseSlideshow>
                </div>

                <div class="case-popup__info-box">
                    <ScrollBar class="case-popup__info-box-scroll">
                        <div class="case-popup__info-box-heading">{{factsAboutDk.heading2050}}</div>
                        <div class="case-popup__info-box-content" v-html="factsAboutDk.text2050"></div>
                    </ScrollBar>
                </div>

                <div v-if="factsAboutDk.facts2050" class="case-popup__facts facts" :class="{'facts--single-column': factsAboutDk.facts2050.length <= 4}">
                    <div v-for="(fact, i) in factsAboutDk.facts2050" v-bind:key="i" class="facts__fact">
                        <div class="facts__icon">
                            <img :src="imageUrl(fact.image)">
                        </div>
                        <div class="facts__info" v-html="fact.text"></div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
import CaseSlideshow from '@/components/CaseSlideshow.vue';
import config from '@/config.js';
import ScrollBar from '@/components/ScrollBar';

export default {
  name: 'CaseOverlay',
  components: {
      CaseSlideshow: CaseSlideshow,
      ScrollBar: ScrollBar
  },
  props: {
      challengeCase: Object,
      colorTheme: String,
      factsAboutDk: Object
  },
  data()
  {
      return {
          currentTab: 'today'
      }
  },
  computed:
  {
    tabTodayLabel()
    {
        return (this.factsAboutDk.tab1Label) ? this.factsAboutDk.tab1Label : 'Today';
    },
    tab2030Label()
    {
        return (this.factsAboutDk.tab2Label) ? this.factsAboutDk.tab2Label : '2030';
    },
    tab2050Label()
    {
        return (this.factsAboutDk.tab3Label) ? this.factsAboutDk.tab3Label : '2050';
    } 
  },
  methods:
  {
      imageUrl(image)
      {
          var url = config.umbracoMediaPath + image.src;
          return url;
      }
  }
}
</script>